import { type FC } from "react";

import { dropdownButtonContainer } from "../shared";

import { Header, SubTitle, Title } from "./funnelTab.styles";

export const EngagementBreakdownHeader: FC = () => {
    return (
        <Header className={dropdownButtonContainer}>
            <div>
                <Title>Engagement Breakdown</Title>
                <SubTitle>Learn about how Snapchatters are engaging with your Lens by user type</SubTitle>
            </div>
        </Header>
    );
};
